import { useEffect, useState } from 'react';

const PULSE_ANIM_MS = 1000;
const WAIT_AFTER_PULSE_MS = 30000;

/** 1 sn parla/sön, 30 sn bekle, tekrarla. */
export function useGameFabPulse() {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    let timeoutId;
    let cancelled = false;

    const runCycle = () => {
      setPulse(true);
      timeoutId = setTimeout(() => {
        setPulse(false);
        if (!cancelled) {
          timeoutId = setTimeout(runCycle, WAIT_AFTER_PULSE_MS);
        }
      }, PULSE_ANIM_MS);
    };

    runCycle();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, []);

  return pulse;
}
